import { FlowTypes } from 'store/constants';
import { useAppSelector } from 'store/hooks';
import { currentDepositMethodSelector } from 'store/slices/deposit';
import { currentWithdrawalMethodSelector } from 'store/slices/withdrawal';

import { getPayGroupCashierContext } from './eventsHelpers';

export const useGetClickStreamPayGroupCashierContext = (type = 'deposit') => {
  const selectorName = type === FlowTypes.withdrawal ? currentWithdrawalMethodSelector : currentDepositMethodSelector;
  const method = useAppSelector(selectorName);
  return getPayGroupCashierContext(method);
};
